module.exports = __webpack_public_path__ + "static/img/img.8e16743.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/slideVerify/assets/img.jpg
// module id = I5hB
// module chunks = 1